export const storeTypes = {
  getters: {
    isEditing: "IS_EDITING",
    isLoading: "IS_LOADING",
    getColorScheme: "GET_COLOR_SCHEME",
    getPreviousRoute: "GET_PREVIOUS_ROUTE",
    getUploadedData: "GET_UPLOADED_DATA",
    getUser: "GET_USER",
    showEditingDialog: "SHOW_EDITING_DIALOG",
  },
  mutations: {
    closeEditingDialog: "CLOSE_EDITING_DIALOG",
    editingStart: "EDITING_START",
    editingStop: "EDITING_STOP",
    loadingStart: "LOADING_START",
    loadingStop: "LOADING_STOP",
    openEditingDialog: "OPEN_EDITING_DIALOG",
    resetUploadedData: "RESET_UPLOADED_DATA",
    setPreviousRoute: "SET_PREVIOUS_ROUTE",
    setUploadedData: "SET_UPLOADED_DATA",
    setUser: "SET_USER",
  },
};
